import APIRequestService from './APIRequestService';

const request = new APIRequestService();

export const getFundCategoriesByClient = async ({ selectedClient }) => {
  const url = `/fiduciaryclients/${selectedClient}/categories`;
  return request.get(url);
};

export const getFundCategoriesByFiduciary = async ({ selectedFiduciary }) => {
  const url = `/fiduciaries/${selectedFiduciary}/categories`;
  return request.get(url);
};

export const getAllClientFundCategories = async (queryParams) => {
  const url = `/universe-funds/all-categories-for-sharedclasses-clients?${queryParams}`;
  return request.get(url);
};
